import FingerprintJs from '@fingerprintjs/fingerprintjs';
import {useState, useEffect} from 'react';

export const useGetFingerprint = () => {
    const [fingerprint, setFingerprint] = useState(null);

    useEffect(() => {
        const setFp = async () => {
            const fp = await FingerprintJs.load();

            const {visitorId} = await fp.get();

            setFingerprint(visitorId);
        };
        setFp();
    }, []);

    return fingerprint;
};
